const postalAddress = '3 rue Luxite, 1899 Kockelscheuer Roeser, Luxembourg';

export const alcyoneContactInformation = {
    phoneNumber: '+352 27 86 17 46',
    emailAddress: 'contact@aco.pro',
    webSite: 'https://aco.pro/',
    postalAddress: postalAddress,
};

export const lusisContactInformation = {
    phoneNumber: '+352 31 35 02 1',
    emailAddress: 'contact@aco.pro',
    webSite: 'https://aco.pro',
    postalAddress: postalAddress,
};
